import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { Link } from 'react-router-dom';


const Footer = () => {
    return (
        <div >
            <footer className="bg-green-800 py-7 text-white">
                <div className="container mx-auto grid grid-cols-1 gap-7 px-6 md:grid-cols-4">

                    {/* <!-- Logo & About --> */}
                    <div>
                        <Link to="/" aria-label="Vasundhara Seeds home"><img src='/logo_hindi.jpeg' alt="Vasundhara Seeds" className='h-10 rounded-full' /></Link>
                        <p className="text-gray-300 text-sm">
                            Bringing you the best services with a commitment to excellence and sustainability.
                        </p>
                    </div>

                    {/* <!-- Quick Links --> */}
                    <div>
                        <h3 className="mb-3 border-b-2 border-yellow-500 text-base font-semibold">Quick Links</h3>
                        <ul className="space-y-1.5 text-sm text-gray-300">
                            <li><Link to="/" className="hover:text-white transition">Home</Link></li>
                            <li><Link to="/about-us" className="hover:text-white transition">About Us</Link></li>
                            <li><Link to="/infrastructure" className="hover:text-white transition">Infrastructure</Link></li>
                            <li><Link to="/products" className="hover:text-white transition">Products</Link></li>
                            <li><Link to="/contact" className="hover:text-white transition">Contact</Link></li>
                            <li><Link to="/privacy-policy" className="hover:text-white transition">Privacy Policy</Link></li>
                            <li><Link to="/terms-and-conditions" className="hover:text-white transition">Terms &amp; Conditions</Link></li>
                        </ul>
                    </div>

                    {/* <!-- Contact Info --> */}
                    <div>
                        <h3 className="mb-3 border-b-2 border-yellow-500 text-base font-semibold">Connect With Us</h3>
                        <div className="space-y-2 text-sm text-gray-300">
                            <p className="flex items-start gap-2"><img src='/map.png' alt="" className="mt-0.5 h-4 w-4" />53 D Badi Udyogpuri, Maxi Rd, near Mahaveer Toll Kata, Agrasen Nagar, Ujjain, Madhya Pradesh 456010</p>
                            <p className="flex items-center gap-2"><img src='/email.png' alt="" className="h-4 w-4" /><a href="mailto:sarang@vasundharaseeds.in" className="hover:text-white">sarang@vasundharaseeds.in</a></p>
                            <p className="flex items-center gap-2"><img src='/phone.png' alt="" className="h-4 w-4" /><a href="tel:+919425332127" className="hover:text-white">+91 9425332127</a></p>
                        </div>
                    </div>

                    {/* <!-- Social Media --> */}
                    <div>
                        <h3 className="mb-3 border-b-2 border-yellow-500 text-base font-semibold">Join our Social Networks</h3>
                        <div className="flex space-x-3">
                            <a href="https://m.facebook.com/Vasundharaseedsujjain/" aria-label="Facebook" className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-lg text-green-900 transition hover:bg-green-700 hover:text-white">
                                <FontAwesomeIcon icon={faFacebookF} />
                            </a>
                            <a href="https://www.instagram.com/" aria-label="Instagram" className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-lg text-green-900 transition hover:bg-green-700 hover:text-white">
                                <FontAwesomeIcon icon={faInstagram} />
                            </a>
                            <a href="https://x.com/" aria-label="X (Twitter)" className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-lg text-green-900 transition hover:bg-green-700 hover:text-white">
                                <FontAwesomeIcon icon={faTwitter} />
                            </a>
                            <a href="https://youtube.com/@sarangmanage10?si=qEai_gMTGyKLr3xi" aria-label="YouTube" className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-lg text-green-900 transition hover:bg-green-700 hover:text-white">
                                <FontAwesomeIcon icon={faYoutube} />
                            </a>
                        </div>
                    </div>
                </div>
            </footer>

            {/* <!-- Bottom Bar --> */}
            <div className="border-t border-yellow-600 bg-green-900 px-4 py-3 text-center text-xs text-white">
                Copyright©2025 Vasundhara Seeds | <Link to="/privacy-policy" className="underline hover:text-yellow-300">Privacy Policy</Link> | <Link to="/terms-and-conditions" className="underline hover:text-yellow-300">Terms &amp; Conditions</Link> | Design and Developed by: Kaizen ThinkWorks
            </div>
        </div>
    );
};

export default Footer;
